import { z } from 'zod'
import { HexNumber } from '@lukso/controllerapps-sharedlogic-primitives'

import { PostDeploymentModule } from '../../../cross-chain-deployment/PostDeploymentModule'

export const PostDeploymentModuleSchema = z.string()

type PostDeploymentModuleReportText = z.infer<typeof PostDeploymentModuleSchema>

export function mapDomainToReportText(
  postDeploymentModule: PostDeploymentModule
): PostDeploymentModuleReportText {
  return postDeploymentModule.getValue().getValue()
}

export function mapReportTextToDomain(
  reportText: PostDeploymentModuleReportText
): PostDeploymentModule {
  return PostDeploymentModule.create({
    postDeploymentModuleValue: HexNumber.create({ hexNumberValue: reportText }),
  })
}
